import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import SolidButton from "../components/buttons/solid-button/SolidButton";
import { useForm } from "react-hook-form";
import logo from "../images/sproxillogo.png";
import FormValidationError from "../components/flash_message/FormValidationError";
import { userForgotPassword } from "../utils/apis/api";
import { useMutation } from "react-query";
import useAuth from "../hooks/useAuth";
import Footer from "../components/footer/Footer";
import ErrorFlash from "../components/flash_message/ErrorFlash";
import { useEffect, useState } from "react";
import { Input } from "../components/inputs/Input";

const Container = styled.div`
	margin-top: 70px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 10px;
	@media screen and (min-width: 480px) {
		margin-top: 120px;
	}
`;
const Wrapper = styled.div`
	width: 100%;
`;

const Heading = styled.div`
	width: 100%;
	margin-top: 30px;
	@media screen and (min-width: 480px) {
		margin-top: 0;
		margin-left: 100px;
	}
`;
const HeadingHeader = styled.div`
	display: flex;
	justify-content: start;

	font-weight: 700;
	font-size: 20px;
	line-height: 45px;
	line-height: 151%;
	color: #1c1939;
	margin: 5px 0;
	@media screen and (max-width: 480px) {
		font-size: 17px;
		justify-content: center;
		margin-left: 0px;
	}
`;

const FormContainer = styled.div`
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;
const FormWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: white;
	flex-grow: 1;
	border-radius: 10px;
	max-width: 700px;
	padding: 20px;
	@media screen and (max-width: 480px) {
		background-color: transparent;
	}
`;

const Form = styled.form`
	width: 87%;
`;
const Label = styled.label`
	padding: 5px;
	width: 100%;
	font-size: ${(props) => props.fontSize};
	color: ${(props) => props.color};
	text-align: ${(props) => props.textAlign};
`;
const FormInputControl = styled.div`
	width: 100%;
	margin: 10px 0;
`;

const HeaderImg = styled.div`
	text-align: center;
	@media screen and (min-width: 480px) {
		margin: 20px 0;
	}
`;
const ErrorMessage = styled.p`
	@media screen and (max-width: 480px) {
		font-size: 10px;
	}
`;

const ForgotPassword = () => {
	const { setLoading } = useAuth();
	const navigate = useNavigate();
	const [errorResponse, setErrorResponse] = useState(
		"This application need to access your location",
	);
	const [noLocation, setNoLocation] = useState(true);

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm();

	const forgotPasswordResponse = async (data) => {
		return await userForgotPassword(data);
	};
	const onSubmit = async (data) => {
		mutate(data);
	};

	const { mutate, isLoading, isError } = useMutation(
		(variables) => forgotPasswordResponse(variables),
		{
			onSuccess(data, variables, context) {
				setLoading(false);
				navigate("/reset-password", { replace: true });
			},
			onError(error) {
				if (error.code !== "ERR_NETWORK") {
					setErrorResponse(error.response.data.message);
				} else {
					setErrorResponse("Please Check Your Network");
				}
			},
		},
	);
	useEffect(() => {
		setLoading(isLoading);
	}, [isLoading, setLoading]);

	useEffect(() => {
		navigator.permissions.query({ name: "geolocation" }).then((resp) => {
			if (resp.state === "granted" || resp.state === "prompt") {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(success, error);
				}
			} else if (resp.state === "denied") {
				setNoLocation(true);
				setErrorResponse(
					"This application need to access your location",
				);
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(success, error);
				}
			}
		});

		function success(position) {
			setNoLocation(false);
		}

		function error(err) {
			console.error(err);
			setErrorResponse("Please application need to access your location");
			setNoLocation(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<Container>
				<Wrapper>
					<HeaderImg>
						<img src={logo} alt="" />
					</HeaderImg>
					<FormContainer>
						<FormWrapper>
							<ErrorFlash display={isError || noLocation}>
								<ErrorMessage>{errorResponse}</ErrorMessage>
							</ErrorFlash>

							<Heading>
								<HeadingHeader>
									Forgot your password?
								</HeadingHeader>
							</Heading>
							<Form onSubmit={handleSubmit(onSubmit)}>
								<FormInputControl>
									<Label fontSize={"14px"}>
										Email Address
									</Label>
								</FormInputControl>
								<FormInputControl>
									<Input
										width={"100%"}
										type="email"
										placeholder={"johndoe@mail.com"}
										{...register("email", {
											required: true,
											pattern: /^\S+@\S+$/i,
										})}
										name="email"
										autoComplete="off"
									/>
									{errors.email?.type === "required" && (
										<FormValidationError
											text={"Email is required"}
										/>
									)}
									{errors.email?.type === "pattern" && (
										<FormValidationError
											text={" Not a valid email"}
										/>
									)}
								</FormInputControl>

								<FormInputControl
									style={{
										display: "flex",
										justifyContent: "space-between",
									}}
								>
									<Label textAlign={"end"}>
										<Link
											to={"/"}
											style={{
												color: "#BE0303",
												fontSize: "13px",
												textDecoration: "none",
											}}
										>
											Back to login
										</Link>
									</Label>
								</FormInputControl>
								<br />
								<FormInputControl style={{ margin: "7px 0" }}>
									<SolidButton
										text={"Next Step"}
										width={"100%"}
									/>
								</FormInputControl>
							</Form>
						</FormWrapper>
					</FormContainer>
				</Wrapper>
			</Container>
			<Footer />
		</>
	);
};

export default ForgotPassword;
